import React, { useState } from 'react';
import { Table, Form, Button, Modal, Pagination, Container } from 'react-bootstrap';
import './css/MainParentCategory.css';
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

const mainCategoriesData = [
  { id: 1, motherCategory: 'Pest Control Service', name: 'Termite Control', logo: '', description: 'Housecareonline provide most scientific, comprehensive Termite control...', keywords: 'Termite control, Termite treatment', seoName: 'termite-control', status: 'Active' },
  { id: 2, motherCategory: 'Health Care Services', name: 'Nurse and Aya', logo: '', description: 'Housecareonline.in services bring Nurse and Aya care at your doorstep...', keywords: 'Nurse and Aya', seoName: 'nurse-and-aya', status: 'Active' },
  { id: 3, motherCategory: 'Health Care Services', name: 'Physiotherapist', logo: '', description: 'housecareonline provides comprehensive physiotherapy...', keywords: 'physiotherapy', seoName: 'physiotherapist', status: 'Active' },
];

const ITEMS_PER_PAGE = 10;

function MainParentCategory() {
  const [categories, setCategories] = useState(mainCategoriesData);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [newCategory, setNewCategory] = useState({
    motherCategory: '',
    name: '',
    logo: null,
    description: '',
    keywords: '',
    seoName: ''
  });

  // Filter and paginate
  const filteredCategories = categories.filter(cat =>
    cat.motherCategory.toLowerCase().includes(search.toLowerCase()) ||
    cat.name.toLowerCase().includes(search.toLowerCase()) ||
    cat.seoName.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCategories.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCategories = filteredCategories.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Modal controls
  const handleShow = () => {
    setEditingId(null);
    setNewCategory({
      motherCategory: '',
      name: '',
      logo: null,
      description: '',
      keywords: '',
      seoName: ''
    });
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  // Input change handler
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo') setNewCategory({ ...newCategory, logo: files[0] });
    else setNewCategory({ ...newCategory, [name]: value });
  };

  // Add or Update
  const handleSave = () => {
    if (!newCategory.name || !newCategory.motherCategory) {
      alert('Please fill all required fields');
      return;
    }

    if (editingId) {
      // Update existing category
      setCategories(categories.map(cat =>
        cat.id === editingId ? { ...cat, ...newCategory } : cat
      ));
    } else {
      // Add new category
      setCategories([
        ...categories,
        { ...newCategory, id: categories.length + 1, status: 'Active' }
      ]);
    }

    handleClose();
  };

  // Edit handler
  const handleEdit = (id) => {
    const cat = categories.find(c => c.id === id);
    if (cat) {
      setEditingId(id);
      setNewCategory({
        motherCategory: cat.motherCategory,
        name: cat.name,
        logo: null, // reset file input
        description: cat.description,
        keywords: cat.keywords,
        seoName: cat.seoName
      });
      setShowModal(true);
    }
  };

  // Delete handler
  const handleDelete = (id) => {
    if (window.confirm('Are you sure to delete this category?')) {
      setCategories(categories.filter(cat => cat.id !== id));
    }
  };

  return (
    <Container fluid className="admin-main-container">
      <h2 className="admin-heading">Manage Parent Category</h2>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '300px' }}
        />
        <Button variant="primary" onClick={handleShow}>Add Parent Category</Button>
      </div>

      <div className="table-container" style={{ fontSize: "14px" }}>
        <Table bordered hover responsive>
          <thead className="custom-thead">
            <tr>
              <th>SL NO.</th>
              <th>Main Category Name</th>
              <th>Parent Category Name</th>
              <th>Parent Category Logo</th>
              <th>Parent Category Description</th>
              <th>Parent Category Keyword</th>
              <th>SEO Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentCategories.length ? currentCategories.map((cat, idx) => (
              <tr key={cat.id} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
                <td>{startIndex + idx + 1}</td>
                <td>{cat.motherCategory}</td>
                <td>{cat.name}</td>
                <td>{cat.logo ? cat.logo.name : 'No Logo'}</td>
                <td>{cat.description}</td>
                <td>{cat.keywords}</td>
                <td>{cat.seoName}</td>
                <td>
                  <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleEdit(cat.id)}>
                    <FiEdit />
                  </Button>
                  <Button variant="outline-danger" size="sm" onClick={() => handleDelete(cat.id)}>
                    <RiDeleteBin6Line />
                  </Button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="8" className="text-center">No categories found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Pagination className="justify-content-center mt-3">
        <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item key={idx + 1} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Edit Main Category' : 'Add Main Category'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Mother Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Mother Category"
                name="motherCategory"
                value={newCategory.motherCategory}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Main Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Main Category Name"
                name="name"
                value={newCategory.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Main Category Logo</Form.Label>
              <Form.Control type="file" name="logo" onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Main Category Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={newCategory.description}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Main Category Keywords</Form.Label>
              <Form.Control
                type="text"
                name="keywords"
                value={newCategory.keywords}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>SEO Name</Form.Label>
              <Form.Control
                type="text"
                name="seoName"
                value={newCategory.seoName}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>
            {editingId ? 'Save Changes' : 'Add Category'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default MainParentCategory;
